import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function SalaryList(){


  const [empData, setempData] = useState([]);

const [startMonth, setStartMonth] = useState(null);
const [endMonth, setEndMonth] = useState(null);

const handleStartMonthChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setStartMonth(localDate);
};

const handleEndMonthChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setEndMonth(localDate);
};

  useEffect(() => {
      fetchotData();
      const intervalId = setInterval(fetchotData, 5000);
      return () => clearInterval(intervalId);
  }, [startMonth, endMonth]);

  function fetchotData() {
    const startMonthString = startMonth ? startMonth.toISOString().substring(0, 7) : '';
    const endMonthString = endMonth ? endMonth.toISOString().substring(0, 7) : '';
    const url = `${baseUrl}salary-view/?start_month=${startMonthString}&end_month=${endMonthString}`;
      axios.get(url)
      .then(response => {
        setempData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }


    const columns = [
        {field:'emp__emp_id', headerName:'Emp ID', width: 80},
        {field:'emp__emp_code', headerName:'Emp Code', width:120},
        {field:'emp__employee', headerName:'Employee', width:150},
        {field:'emp__experience', headerName:'Experience', width:80},
        {field:'emp__designation__designation', headerName:'Designation', width:130},
        {field:'emp__earnings', headerName:'Tot Earnings/M', width:130},
        {field:'emp__deduction', headerName:'Tot Deduction/M', width:130},
        {field:'emp__ctc', headerName:'CTC', width:110},
        {field:'pay', headerName:'Salary', width:110},
        {field:'emp__pan', headerName:'PAN', width:130},
        { field: 'payslip', headerName: 'Payslip',
          renderCell: (params) => (
                    <Link to={`/view-payslip/${params.row.emp__id}/${params.row.id}/`} className="btn btn-success">
                <i className="fa-solid fa-money-bill"></i>
              </Link>
          ),
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
      ];

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Salary Statement Date-wise</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
           <DatePicker
                selected={startMonth}
                onChange={handleStartMonthChange}
                selectsStart
                startDate={startMonth}
                endDate={endMonth}
                placeholderText={'Please select From month'}
                showMonthYearPicker
                dateFormat="MM/yyyy"
            />
            <DatePicker
                selected={endMonth}
                onChange={handleEndMonthChange}
                selectsEnd
                startDate={startMonth}
                endDate={endMonth}
                minDate={startMonth}
                placeholderText={'Please select To month'}
                showMonthYearPicker
                dateFormat="MM/yyyy"
            />
            </div>

          </div>
        </div>
      </div>

        <div style={{ height: '100%', width: '100%' }} className="mt-4">
        {empData.length > 0 && (
            <>
            <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
              <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
              Employee Salary List
            </h3>
            <DataGrid
            sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            }}
            rows= {empData}
            columns= {columns}
            pageSize= {10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
            />
          </>
        )}
    </div>
    </section>
    )
}

export default SalaryList;
